export default __webpack_public_path__ + "static/media/karavan-social-networking-app-screen.e2b53c77.png";